import React from 'react'
import EditRotationDetails from "./edit-rotation-details";
import RenderFields from "../../../../common/ui/render-fields";
import {TEXT_PATH_FIELD_LIST} from "../../../constants/design.constant";

const EditTextPathDetails = ({parentItem, handleTextPathDetailsChanges}) => {

    const handleDetailChanges = (event) => {
        handleTextPathDetailsChanges(event, parentItem);
    }

    return (
        <>

            <div className="flex flex-wrap justify-start">
                <RenderFields
                    parentForm={parentItem}
                    handleDetailChanges={handleDetailChanges}
                    fieldList={TEXT_PATH_FIELD_LIST}
                    enableEdit={true}
                    fieldClassName={'w-1/2'}/>
            </div>
        </>
    )
}

export default EditTextPathDetails
